import { render } from "./reportNumber.vue?vue&type=template&id=2e46bce7&scoped=true"
import script from "./reportNumber.vue?vue&type=script&lang=js"
export * from "./reportNumber.vue?vue&type=script&lang=js"

import "./reportNumber.vue?vue&type=style&index=0&id=2e46bce7&scoped=true&lang=css"
import "./reportNumber.vue?vue&type=style&index=1&id=2e46bce7&lang=css"
script.render = render
script.__scopeId = "data-v-2e46bce7"

export default script